import { Component, Input, OnInit } from '@angular/core';
import { NgxIndexedDBService } from 'ngx-indexed-db';
import { InternalService } from './shared/services/internal.service';
import { TranslateService } from '@ngx-translate/core';
import { ApiService } from './shared/services/api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Meta } from '@angular/platform-browser';
// import { SwUpdate } from '@angular/service-worker';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'Alobodo';
  lang;

  constructor(public dbService: NgxIndexedDBService,
    public internalService: InternalService,
    public translate: TranslateService,
    private meta: Meta,
    // private swUpdate: SwUpdate,
    public apiService: ApiService) {

      

    if (!localStorage.getItem('lang')) {
      this.internalService.changeLang('fa-ir', 0);
      
      this.apiService.detectLanguage().then(language => {
        console.log('App Language:', language);

        if (language || language != null) {
          if (language == 'fa') {
            this.internalService.changeLang('fa-ir', 0); // Persian
            document.title = 'الوبدو';
          } else {
            this.internalService.changeLang('en-us', 0);
            document.title = 'Alobodo';
          }
        } else {
          this.apiService.getMyIP().subscribe((res: any) => {
      
            const body = {
              visitorIp: res.iP
            }
            
            this.apiService.getLocationFromAPI(body).subscribe((response: any) => {
              
              if (response.res || response.res != 'IR') {
                this.internalService.changeLang('en-us', 0);
                document.title = 'Alobodo';
              }
              else {
                this.internalService.changeLang('fa-ir', 0); // Persian
                document.title = 'الوبدو';
              }
            })
          })
        }
      });

      

      // this.apiService.detectLanguage();
      
    
        // if (language || language == "fa") {
        //   this.internalService.changeLang('fa-ir', 0); // Persian
        //   document.title = 'الوبدو';
        // }
        // else {
        //   this.internalService.changeLang('en-us', 0);
        //   document.title = 'Alobodo';
        // }
      
    } else {
      if (localStorage.getItem('lang') === '1') {
        this.changeLanguage('fa-ir');
        localStorage.setItem('dir', 'rtl')
      } else {
        this.changeLanguage('en-us');
        localStorage.setItem('dir', 'ltr')
      }
    }




    // if (!localStorage.getItem('lang')) {
    //   this.apiService.detectLanguage().then(response => {
    //     console.log(response);
        
    //     if (response || response != 'fa') {
    //       this.internalService.changeLang('en-us', 0);
    //       document.title = 'Alobodo';
    //     }
    //     else {
    //       this.internalService.changeLang('fa-ir', 0); // Persian
    //       document.title = 'الوبدو';
    //     }
    //   });
    // }
    // else {
    //   if (localStorage.getItem('lang') === '1') {
    //     this.changeLanguage('fa-ir');
    //     localStorage.setItem('dir', 'rtl')
    //   } else {
    //     this.changeLanguage('en-us');
    //     localStorage.setItem('dir', 'ltr')
    //   }
    // }

    // if (localStorage.getItem('dir') === 'rtl' || localStorage.getItem('dir') == null || !localStorage.getItem('dir')) {
    //   this.apiService.currentDirection = localStorage.getItem('dir');
    //   this.changeLanguage('fa-ir');
    //   localStorage.setItem('dir', 'rtl')
    // } else {
    //   this.apiService.currentDirection = localStorage.getItem('dir');
    //   this.changeLanguage('en-us');
    // }

    // this.translate.get('Menu.AlobodoAdminPanel').subscribe(res =>{
    //   this.title.setTitle(res)
    // })
  }

  ngOnInit() {
    this.setMetaDescription();
  }

  setMetaDescription(): void {
    const userLang = navigator.language;
    console.log(userLang);
    
    if (userLang.startsWith('fa')) {
      // this.title.setTitle("عنوان صفحه به فارسی"); // Set Page Title (Optional)
      this.meta.updateTag({ name: 'description', content: "الوبدو اپلیکیشن درخواست خدمات آنلاین است که به کاربران خود امکان می‌دهد در هر ساعتی از شبانه روز به راحتی سفارش به ثبت برساند و منتظر پاسخی از سوی تکنسین‌های مرتبط بماند تا بتواند خدمات مختلفی را دریافت نماید" });
    } else {
      // this.title.setTitle("Page Title in English"); // Set Page Title (Optional)
      this.meta.updateTag({ name: 'description', content: "Alobodo is an online service request application that allows its users to easily place their orders at any time of the day or night and wait for a response from relevant technicians to receive various services." });
    }
  }

  changeLanguage(lang) {
    this.internalService.changeLang(lang, 0);
  }



}


